import type {
  BetterstartCommandRuntime,
  UpdateDepsCommandOptions
} from '@cli-types/core-engine/commands.js'
import { Command } from 'commander'

export function createUpdateDepsCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('update-deps')
    .description('Install or update all Admin dependencies')
    .option('--cwd <path>', 'Project root path')
    .action((options: UpdateDepsCommandOptions) => runtime.runUpdateDeps(options))
}
